//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import template from './streams-drawer-summary-header.html';
import './streams-drawer-summary-header.less';

import '@services/user-settings-api.service';

class StreamsDrawerSummaryHeader {
  public readonly clientName: string;
  public headerText: string;
  public subtitleText: string;
  public onCloseContentDiscoveryFirstRunCard: () => any;

  public $onInit() {
    this.headerText = 'Recommended For You';
    this.subtitleText = `Here are some recommendations we've curated just for ${this.clientName}.`;
  }

  public onCloseClick() {
    this.onCloseContentDiscoveryFirstRunCard();
  }
}

angular.module('curalate').component('streamsDrawerSummaryHeader', {
  bindings: {
    clientName: '<',
    isFetchingFirstRunStatus: '<',
    onCloseContentDiscoveryFirstRunCard: '&',
    showContentDiscoveryFirstRun: '<',
  },
  controller: [
    'UserSettingsApiService',
    StreamsDrawerSummaryHeader,
  ],
  template,
});
